import {  useState } from 'react';
import {obtenerActividades} from '../data/Agenda';
import {obtenerAsistenciaMesAno,actualizarAsistenciaMesAno} from '../data/Asistencia';
import { useContext } from "react";
import { AuthContext } from "auth";

import moment from 'moment';
import 'moment/locale/es';

export const useRegistroAsistencia= () => {
    var {user}= useContext(AuthContext);
    
    const [actividadActual,setActividadActual]=useState();
    const [actividadesSelector,setActividadesSelector]=useState([])
    const [columnasAsistenciaMes,setColumnasAsistenciaMes]=useState([])
    const [asistenciaMesAno,setAsistenciaMesAno]=useState([])
    const [respuestaActualizarAsistencia, setRespuestaActualizarAsistencia] = useState({mensajeTexto:"",estado:false});
   
    
    const getActividadesSelector= async() => {
        const respuesta=await obtenerActividades(user.Token);
        let opcionesSelector=[];
        respuesta?.map((elem)=>{
              opcionesSelector.push(
                  {
                      value:elem.Valor,
                      label:elem.Descripcion==null || elem.Descripcion.trim()==''?elem.Nombre: elem.Nombre+'('+elem.Descripcion+')',
                      index:elem.Valor
                  }
              )
        });
        setActividadesSelector(opcionesSelector);
        console.log(opcionesSelector)
        setActividadActual(opcionesSelector[0].value)
    }

    const getAsistenciaMesAno= async(Asistencia) => {
        if(Asistencia.Ano>0 && Asistencia.Mes>0 && Asistencia.ActividadId>0){
            const respuestaAsistencia=await obtenerAsistenciaMesAno(Asistencia,user.Token);
            setAsistenciaMesAno(respuestaAsistencia.Asistencia);
            setColumnasAsistenciaMes(respuestaAsistencia.Columnas);
        }
    }
    
    const updateAsistenciaMesAno=async(Asistencia)=>{
        if(Asistencia!=null){
            const respuesta=await actualizarAsistenciaMesAno(Asistencia,user.Token);
            if(respuesta!=undefined)
            {
                setRespuestaActualizarAsistencia({estado:respuesta.success,mensajeTexto:respuesta.message})
            }
            else
            {
                setRespuestaActualizarAsistencia({estado:false,mensajeTexto:"Se produjo un error"})
            }
            return respuesta;
        }
    }
  
    return {
        getActividadesSelector,
        actividadesSelector,
        columnasAsistenciaMes,
        getAsistenciaMesAno,
        asistenciaMesAno,
        setAsistenciaMesAno,
        updateAsistenciaMesAno,
        respuestaActualizarAsistencia,
        setActividadActual,
        actividadActual
    }
}
